<!-- Channel and Stage Listing -->
<p-table [value]="channels" dataKey="id" cdkDropList (cdkDropListDropped)="dropStage($event)">
    <ng-template pTemplate="header">
        <tr>
            <th style="max-width: 3rem"></th>
            <th> {{'Configuration.CRM.Name' | transloco }} </th>
            <th *ngIf="leadOwnerSettings?.enabled"> Owner Name </th>
            <th> {{'Configuration.CRM.Count' | transloco }} </th>
            <th *ngIf="moduleId === oppModuleId"> Status </th>
            <th *ngIf="moduleId === oppModuleId"> Probability </th>
            <th *ngIf="moduleId === oppModuleId"> Forecast Category </th>
            <th> {{'Configuration.CRM.Created_By' | transloco }} </th>
            <th> {{'Configuration.CRM.Last_Modified' | transloco }} </th>
            <th> {{'Configuration.CRM.Is_Active' | transloco }} </th>
            <th> {{'Configuration.CRM.Is_Default' | transloco }} </th>
            <th> {{'Configuration.CRM.Action' | transloco }} </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-channel let-i="rowIndex" let-expanded="expanded">
        <tr style="background: #f1f1f1;">
            <td>
              <button type="button" [pRowToggler]="channel" pButton pRipple
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  *ngIf="channel.numberOfStages"
                  (click)="getChannelStages(!expanded, channel.id)"
                  style="width: 20px;height: 20px;">
              </button>
            </td>
            <td> {{ channel.name }} </td>
            <td *ngIf="leadOwnerSettings?.enabled"> {{ channel?.ownerName}} </td>
            <td> {{ channel.numberOfStages }} </td>
            <td *ngIf="moduleId === oppModuleId"></td>
            <td *ngIf="moduleId === oppModuleId"></td>
            <td *ngIf="moduleId === oppModuleId"></td>
            <td> {{ channel.createdByName }} </td>
            <td> {{ channel.lastUpdatedDate | localDate }} </td>
            <td> {{ channel.isActive ? answertypeConstants.Yes: answertypeConstants.No }} </td>
            <td>
                <p-radioButton [disabled]="!channel.isActive" [value]="true" [(ngModel)]="channel.isDefault"
                    (onClick)="setDefaultChannel(channel)">
                </p-radioButton>
                {{ channel.isDefault ? answertypeConstants.Yes: answertypeConstants.No }}
            </td>
            <td class="action">
                <span class="btnBars p-mr-0" (click)="showCreateUpdateChannelModal('edit', channel)" pTooltip="Edit"
                    tooltipPosition="top">
                    <i class="pi pi-pencil"></i>
                </span>
                <span class="btnBars p-mr-0" (click)="showCreateUpdateStageModal('create stage', channel)" pTooltip="Add"
                    tooltipPosition="top">
                    <i class="pi pi-plus"></i>
                </span>
                <span class="btnBars p-mr-0" *ngIf="!channel.systemGenerated && !channel.isDefault && moduleId !=leadModuleId"  (click)="deleteChannel(channel.id)"
                    pTooltip="Delete" tooltipPosition="top">
                    <i class="pi pi-trash"></i>
                </span>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="rowexpansion" let-channel>
        <ng-container *ngFor="let stage of channel.stageList">
            <tr [style.cursor]="stage.systemGenerated ? 'auto' : 'move'" cdkDrag (cdkDragStarted)="dragStart($event, channel, stage)" >
                <td style="padding-left: 2rem !important;" class="action">
                  <span *ngIf="!stage.systemGenerated" class="pi pi-bars" pReorderableRowHandle></span>
                </td>
                <td style="padding-left: 2rem !important;"> {{ stage.name }} </td>
                <td *ngIf="leadOwnerSettings?.enabled"> {{ stage?.ownerName}} </td>
                <td></td>
                <td *ngIf="moduleId === oppModuleId">{{(stage.probability== 0 || stage.probability== 100)?stage.name:'Open'}}</td>
                <td *ngIf="moduleId === oppModuleId">{{stage.probability}}</td>
                <td *ngIf="moduleId === oppModuleId">{{stage?.forcastCategoryName}}</td>
                <td> {{ stage.createdByName }} </td>
                <td> {{ stage.lastUpdatedDate | localDate }} </td>
                <td> {{ stage.isActive ? answertypeConstants.Yes: answertypeConstants.No }} </td>
                <td></td>
                <td class="action">
                    <app-color-box [color]="stage.color"></app-color-box>
                    <span class="btnBars p-mr-0" (click)="showCreateUpdateStageModal('update stage', channel, stage)" pTooltip="Edit"
                        tooltipPosition="top">
                        <i class="pi pi-pencil"></i>
                    </span>
                    <span *ngIf="!stage.systemGenerated" class="btnBars p-mr-0" (click)="deleteStage(channel.id, stage.id)"
                        pTooltip="Delete" tooltipPosition="top">
                        <i class="pi pi-trash"></i>
                    </span>
                </td>
            </tr>
        </ng-container>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="8"> {{ noDataChannel }} </td>
        </tr>
    </ng-template>
</p-table>

<!-- Channel Create/Update Modal -->
<p-dialog [header]="channelHeader" [(visible)]="displayCreateUpdateChannel" [modal]="true"
*ngIf="displayCreateUpdateChannel" appendTo="body"
    [responsive]="true" [style]="{width: '60vw'}" (onHide)="channelForm.reset();cancelCreateUpdateModal()">

    <app-subscription-limit-message
        *ngIf="subscriptionLimitReached"
        [subscriptionLimit]="subscriptionLimit"
        [moduleName]="'Channel'">
    </app-subscription-limit-message>

    <form *ngIf="!subscriptionLimitReached" [formGroup]="channelForm">
      <div class="header">
          <h5> {{ 'Configuration.CRM.Channel_Information' | transloco }}
              <p-inputSwitch class="header-switch" formControlName="isActive" [disabled]="statusDisabled"></p-inputSwitch>
          </h5>
      </div>
      <div class="card">
          <div class="p-field p-formgrid p-grid">
              <div class="p-col-12">
                  <label> {{ 'Configuration.CRM.Channel_Name' | transloco }} <span style="color: red;">*</span></label>
                  <input class="p-mt-2" type="text" pInputText formControlName="name">
              </div>
          </div>
      </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="cancelCreateUpdateModal()" label="{{'Configuration.CRM.Cancel' | transloco}}"
            class="p-button-secondary">
        </button>
        <button *ngIf="!subscriptionLimitReached" type="button" pButton [disabled]="!channelForm.valid" (click)="createUpdateChannel(channelForm.value)"
            label="{{'Configuration.CRM.Save' | transloco}}">
        </button>
    </p-footer>
</p-dialog>

<!-- Stage Create/Update Modal -->
<p-dialog header="{{ createUpdateStageHeader }}" [modal]="true" [(visible)]="displayCreateUpdateStage" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="channelStageForm.reset();">
    <form [formGroup]="channelStageForm" (ngSubmit)="createUpdateChannelStage(channelStageForm.value)" #createUpdateStage="ngForm">
        <div class="header">
            <h5>
                {{'Configuration.CRM.Channel_Stage_Information' | transloco}}
                <p-inputSwitch class="header-switch" formControlName="isActive"></p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label for="name">{{'Configuration.CRM.Stage_Name' | transloco}}<span style="color: red;">*</span></label>
                    <input type="text" pInputText formControlName="name">
                </div>
                <div class="p-col-12 p-md-6">
                    <label>{{'Configuration.CRM.Stage_Color' | transloco}} <span style="color: red;">*</span></label>
                    <p-colorPicker appendTo="body" formControlName="color"></p-colorPicker>
                </div>
                <div class="p-col-12" *ngIf="moduleId === oppModuleId">
                    <label for="name">Forcast Category</label>
                    <p-dropdown [options]="forcastCategoryEditList" formControlName="forcastCategory" name="forcastCategory"
                      placeholder="Choose Forecast category" optionLabel="name"  [showClear]="true"
                      [disabled]="isStageEdit && (channelStageForm.value.probability==0 || channelStageForm.value.probability==100)">
                    </p-dropdown>
                </div>
                <div class="p-col-12" *ngIf="moduleId === oppModuleId">
                    <label for="name">Probability (1 - 99%)</label>
                    <input type="number" pInputText [value]="channelStageForm.value.probability" min="0" max="100" readonly>
                    <p-slider formControlName="probability" [min]="1" [max]="99"
                      [disabled]="isStageEdit && (channelStageForm.value.probability==0 || channelStageForm.value.probability==100)">
                    </p-slider>
                </div>
                <div class="p-col-12" *ngIf="moduleId === oppModuleId">
                    <label for="name">Notes</label>
                    <textarea pInputTextarea formControlName="note" rows="3"></textarea>
                </div>
                <div class="p-col-6" *ngIf="leadOwnerSettings?.enabled">
                    <label for="name">Stage Owner</label>
                    <p-dropdown formControlName="ownerId" [options]="ownerList" optionValue="id" optionLabel="name" placeholder="Choose Owner" appendTo="body" [filter]="true">
                        <ng-template let-user pTemplate="item">
                            <div class="user-item">
                                <div>{{user.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>

            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button pButton (click)="displayCreateUpdateStage = false;" label="{{'Configuration.CRM.Cancel' | transloco}}"
            class="p-button-secondary"></button>
        <button pButton (click)="createUpdateStage.ngSubmit.emit()" [disabled]="!channelStageForm.valid"
            label="{{'Configuration.CRM.Save' | transloco}}">
        </button>
      </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>
